const IMG_PATH = "/img/logo";
const POLYGON_PATH = "/img/polygon";

export const ogLogo = `${IMG_PATH}/OGLOGO.png`;
export const ogLogoBg = `${IMG_PATH}/OGLOGORES.png`;
export const whitePolygon = `${POLYGON_PATH}/whitePolygon.png`;
export const yellowPolygon = `${POLYGON_PATH}/yellowPolygon.png`;
export const yellowAndWhitePolygon = `${POLYGON_PATH}/yellowAndWhitePolygon.png`;
export const downloadLogo = `${IMG_PATH}/download.png`;
